import SkeletonCompanyExperience from './SkeletonCompanyExperience'
export default SkeletonCompanyExperience
